//Dependencies
import React, { useContext } from "react";
import UserContext from "../context/User/UserContext";
import { Modal, Icon, message } from "antd";
import { logout } from "../api/authInstance";
const { confirm } = Modal;

const LogoutComponent = () => {
  const { user, setUser } = useContext(UserContext);

  const handleLogout = () => {
    logout()
      .then(() => {
        localStorage.removeItem("tokenApi");
        setUser(null);
      })
      .catch((err) => {
        message.error("Se produjo un error al cerrar sesión.");
      });
  };

  const handleClose = () => {
    confirm({
      title: "Cerrar sesión",
      content: "¿Está seguro que desea cerrar la sesión?",
      cancelText: "Cancelar",
      okType: "danger",
      okText: "Cerrar sesión",
      onOk: () => handleLogout(),
      onCancel() {},
    });
  };

  return (
    <div
      style={{
        textAlign: "right",
        padding: "0.5rem",
        borderRadius: "5px",
        cursor: "pointer",
        backgroundColor: "#fff",
      }}
      onClick={() => handleClose()}
    >
      <Icon type="poweroff" style={{ color: "#F44336", paddingRight: "5px" }} />
      <span>{user.nomUsuario}</span>
    </div>
  );
};

export default LogoutComponent;
